import { FORMAT_LABELS } from '@jt/core';
import type { ApplicationFull, Score } from '@jt/shared';
import { useAppActions } from '../api/hooks';
import { AreaField, opts, SelectField, TextField } from '../components/fields';

export function ScoreView({ score }: { score: Score }) {
  if (score.value == null)
    return (
      <p className="muted sm" style={{ margin: '8px 0 0' }}>
        Заполните зарплату и формат, а в «Настройках» — свои критерии: появится оценка совпадения.
      </p>
    );
  return (
    <div className="score">
      <div>
        <div className="v">{score.value}</div>
        <div className="muted sm">из 100</div>
      </div>
      <ul>
        {score.parts.map((p) => (
          <li key={p.text} className={p.ok ? '' : 'no'}>
            {p.text}
          </li>
        ))}
      </ul>
    </div>
  );
}

const GUT = [
  ['', '—'],
  ['5', '5 — очень хочу'],
  ['4', '4 — нравится'],
  ['3', '3 — нормально'],
  ['2', '2 — сомневаюсь'],
  ['1', '1 — не моё'],
] as const;

export function OfferTab({ a }: { a: ApplicationFull }) {
  const act = useAppActions();
  const o = a.offer;
  const save = (f: Parameters<typeof act.offer>[1]) => act.offer(a.id, f);
  const num = (v: string | null) => {
    if (v == null || v === '') return null;
    const n = parseFloat(v.replace(/[^\d.,]/g, '').replace(',', '.'));
    if (!isFinite(n)) throw new Error('Число в тысячах евро, например 72.5');
    return n > 1000 ? n / 1000 : n;
  };
  return (
    <>
      <div className="grid">
        <TextField
          label="Зарплата, тыс. € gross/год"
          name="salaryK"
          inputMode="decimal"
          value={o?.salaryK ?? null}
          onSave={(v) => save({ salaryK: num(v) })}
        />
        <TextField
          label="Бонус / переменная часть"
          name="bonus"
          value={o?.bonus ?? ''}
          onSave={(v) => save({ bonus: v ?? '' })}
        />
        <SelectField
          label="Формат"
          name="format"
          value={o?.format ?? null}
          options={opts(FORMAT_LABELS, '—')}
          onSave={(v) => save({ format: v })}
        />
        <TextField
          label="Контракт"
          name="contract"
          value={o?.contract ?? ''}
          placeholder="Indefinido, B2B…"
          onSave={(v) => save({ contract: v ?? '' })}
        />
        <TextField
          label="Дата выхода"
          name="startDate"
          type="date"
          nullable
          value={o?.startDate ?? null}
          onSave={(v) => save({ startDate: v })}
        />
        <TextField
          label="Ответить до"
          name="deadline"
          type="date"
          nullable
          value={o?.deadline ?? null}
          onSave={(v) => save({ deadline: v })}
        />
        <AreaField
          label="Бенефиты и прочие условия"
          name="benefits"
          value={o?.benefits ?? ''}
          onSave={(v) => save({ benefits: v })}
        />
        <SelectField
          label="Ощущение от команды"
          name="gut"
          className="full"
          value={o?.gut != null ? (String(o.gut) as '1') : ''}
          options={GUT}
          onSave={(v) => save({ gut: v ? Number(v) : null })}
        />
      </div>
      <div id="offer-score">
        <ScoreView score={a.score} />
      </div>
    </>
  );
}
